// extracted by mini-css-extract-plugin
export default {"logo":"logo§SOEMvx5enb934Kjy68zl","whatIsThis":"whatIsThis§KvOLb_W7q5l1kMQ6YCrj"};